/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterbrightness1Inputs */

const en_filterbrightness1 = /** @type {(inputs: Filterbrightness1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brightness`)
};

const de_filterbrightness1 = /** @type {(inputs: Filterbrightness1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helligkeit`)
};

/**
* | output |
* | --- |
* | "Brightness" |
*
* @param {Filterbrightness1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterbrightness1 = /** @type {((inputs?: Filterbrightness1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterbrightness1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterbrightness1(inputs)
	return de_filterbrightness1(inputs)
});
export { filterbrightness1 as "filterBrightness" }